import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Кадровый резерв </h1>
            </StartStep>

            <GreyCard>
                <p>
                    <a href="https://academics.hse.ru/hipo/about">«Академический кадровый
                        резерв»</a>&nbsp;&nbsp;программа поддержки
                    профессионального развития преподавателей и
                    исследователей на начальных и переходных этапах академической карьеры
                </p>
                <a href="https://academics.hse.ru/hipo">
                    Академический кадровый резерв
                </a>
            </GreyCard>

            <br/><br/>

            <GreyCard>
                <p>
                    <a href="https://www.hse.ru/aukr/about">"Административный кадровый резерв"</a>
                    &nbsp;&nbsp;программа по развитию административно-управленческого персонала
                </p>
                <a href="https://www.hse.ru/aukr/">
                    Административный кадровый резерв
                </a>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step10">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={100}/>
                        <span>Шаг 11 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step11"
                                disabled>Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;